import {
  DirectSalesProductTemplateSotFilter,
  ProductTemplateRulesResponse,
} from 'components/common/types/DirectSalesProductTemplate.types';
import { ProductManagement, SelectionPermission } from 'store/productManagement/reducer.types';

export const transformSotFromResponse = (
  sotRule: ProductTemplateRulesResponse,
  sotPermission: SelectionPermission,
): ProductManagement['newProduct']['sot'] => {
  if (sotPermission === SelectionPermission.DISABLED) {
    return undefined;
  }

  if (sotRule.behaviour === 'FIXED') {
    return {
      selectionPermission: sotPermission,
      value: {
        defaultValue: (sotRule.fixedSet[0] as DirectSalesProductTemplateSotFilter).target * 100,
        minValue: undefined,
        maxValue: undefined,
      },
    };
  }

  if (sotRule.behaviour === 'RANGE' && sotRule.rangeSet.length > 0) {
    const { min, max, default: defaultValue } = sotRule.rangeSet[0];

    return {
      selectionPermission: SelectionPermission.RANGE_VALUE,
      value: {
        defaultValue: defaultValue ? defaultValue * 100 : undefined,
        minValue: min ? min * 100 : undefined,
        maxValue: max ? max * 100 : undefined,
      },
    };
  }

  return { selectionPermission: sotPermission, value: undefined };
};
